import React from 'react';
import { SidebarProvider } from '@/components/ui/sidebar';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
interface AppLayoutProps {
  children: React.ReactNode;
}
const AppLayout: React.FC<AppLayoutProps> = ({
  children
}) => {
  return <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <main className="flex-1 flex flex-col">
          <AppHeader />
          <div className="flex-1 overflow-auto pt-20 px-[15px]">
            {children}
          </div>
        </main>
      </div>
    </SidebarProvider>;
};
export default AppLayout;